<template>
  <div class="h-28 border text-center bg-salesium-bronze text-white pt-4 mb-7 br-10">
    <div>
      <p class="text-base md:text-lg">Network Reach</p>
      <p class="text-3xl md:text-4xl inline-block">{{ total }}</p>
      <div class="tooltip inline-block">
        <svg-vue icon="circle-question-regular" class="fill-salesium-grey-100 w-6 h-6" />
        <div class="tooltiptext ml-10">Total customers that now can see you based on your connections to other Pros.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    // TODO: dynamically pass in reach total
    props: ['total'],
};
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip:hover {
  cursor: help;
}

/* Tooltip text */
.tooltip .tooltiptext {
  opacity: 0;
  visibility: hidden;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  transition-property: opacity;
  transition-duration: 0.7s;
  opacity: 1;
  visibility: visible;
}
</style>